import bg1 from "../assets/wallpapers/futuristic-black-orange.jpg";
import bg2 from "../assets/wallpapers/pexels-gije-3017050.jpg";
import bg3 from "../assets/wallpapers/pexels-sam-lion-5710218.jpg";
import bg4 from "../assets/wallpapers/pexels-tim-samuel-5835574.jpg";
import boyCarImg from "../assets/wallpapers/boy-car-mix.png";
import React, { useEffect, useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import Services from "./Services";
import Cars from "./Cars";
import Hexagon3DGold from "./Hexagon3DGold";
import "./Home.css";

const backgrounds = [bg1, bg2, bg3, bg4];

export default function Home() {
  const [bgIndex, setBgIndex] = useState(0);
  const formRef = useRef();

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % backgrounds.length);
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => alert("✅ Booking successful! We'll contact you soon."),
        () => alert("❌ Error sending booking. Try again.")
      );
  };

  return (
    <div
      className="home-wrapper"
      style={{
        backgroundImage: `url(${backgrounds[bgIndex]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        transition: "background-image 1s ease-in-out",
      }}
    >
      {/* Hero Section */}
      <section className="hero-section fade-in">
        <div className="hexagon-wrapper">
          <Hexagon3DGold size={250} className="hexagon-hover" />
        </div>
        <div className="hero-content">
          <h1 className="gradient-heading">
            Rental Zone JSR <br /> CAB Service
          </h1>
          <p className="sub-tagline">
            Your journey deserves comfort, safety, and style.
          </p>
        </div>
      </section>

      {/* Booking Section */}
      <section className="booking-section">
        <div className="booking-image">
          <img src={boyCarImg} alt="Book Cab" className="floating-img" />
          <p className="booking-caption">
            “Fast, Safe & Affordable Rides – Book Now to Save Time!”
          </p>
        </div>

        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="booking-form glass-card"
        >
          <h2 className="gradient-heading form-heading">
            Book Your Ride Instantly
          </h2>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            required
          />
          <input
            type="tel"
            name="contact"
            placeholder="Contact Number"
            required
          />
          <input
            type="text"
            name="pickup"
            placeholder="Pickup Location"
            required
          />
          <input
            type="text"
            name="drop"
            placeholder="Drop Location"
            required
          />
          <input type="date" name="date" required />
          <select name="vehicle">
            <option>Dzire</option>
            <option>Ertiga</option>
            <option>Innova</option>
          </select>
          <select name="travelOption">
            <option>Outstation Travel</option>
            <option>Local Travel</option>
          </select>
          <button type="submit" className="btn-booking">
            Confirm Booking
          </button>
        </form>
      </section>

      {/* Services & Cars */}
      <section className="services-section parallax-bg" style={{ background: "transparent" }}>
        <Services />
      </section >
      <section className="cars-section" style={{ background: "transparent" }}>
        <Cars />
      </section>
    </div>
  );
}
